/** Copy for the 360 turntable (Matic360Viewer). */
export const MATIC_360 = {
  label: "360° view of Matic. Drag, or use the arrow keys, to turn it.",
  hint: "DRAG TO ROTATE",
  turned: (degrees: number) => `Turned ${degrees} degrees`,
} as const;
